// Provides shortcuts for choosing dates in the report calendar.
// Users can select a common range such as Today or Last 7 days without locating its
// calendar dates, or switch between selecting individual days, weeks, and months.
import { Resolution, ResolutionOptions } from '../report-settings/reportSettings.ts';
import { QuickRangeKey } from './periodRanges.ts';

const QUICK_RANGES: { key: QuickRangeKey; label: string }[] = [
    { key: 'today', label: 'Today' },
    { key: 'yesterday', label: 'Yesterday' },
    { key: 'this-week', label: 'This week' },
    { key: 'last-week', label: 'Last week' },
    { key: 'last-7-days', label: 'Last 7 days' },
    { key: 'this-month', label: 'This month' },
    { key: 'last-month', label: 'Last month' },
    { key: 'last-30-days', label: 'Last 30 days' },
    { key: 'this-year', label: 'This year' },
    { key: 'last-year', label: 'Last year' },
    { key: 'last-365-days', label: 'Last 365 days' },
];

interface Props {
    resolution: Resolution;
    hideResolution?: boolean;
    // These callbacks edit the calendar dialog's pending selection, not the displayed report.
    onResolutionChange: (resolution: Resolution) => void;
    onQuickRange: (key: QuickRangeKey) => void;
    onClear: () => void;
}

export function RangeToolbar({
    resolution,
    hideResolution = false,
    onResolutionChange,
    onQuickRange,
    onClear,
}: Props) {
    return (
        <div className='report-range-dialog__toolbar'>
            {!hideResolution && <div className='report-range-dialog__resolution' role='group' aria-label='Calendar period type'>
                {ResolutionOptions.map((value) => (
                    <button
                        type='button'
                        key={value}
                        className={resolution === value ? 'selected' : undefined}
                        aria-pressed={resolution === value}
                        onClick={() => onResolutionChange(value)}
                    >
                        {value}
                    </button>
                ))}
            </div>}
            <label className='report-range-dialog__quick'>
                <span>Quick select</span>
                {/* Reset Quick select so the same date shortcut can be chosen again. */}
                <select
                    value=''
                    onChange={(event) => {
                        if (event.target.value) onQuickRange(event.target.value as QuickRangeKey);
                    }}
                >
                    <option value='' disabled>Choose range...</option>
                    {QUICK_RANGES.map((quickRange) => (
                        <option key={quickRange.key} value={quickRange.key}>
                            {quickRange.label}
                        </option>
                    ))}
                </select>
            </label>
            <button type='button' className='report-range-dialog__clear' onClick={onClear}>
                Clear range
            </button>
        </div>
    );
}
